import { Roles } from '../../models/enums';

export const OptionsByRole = [
  {
    role: Roles.Admin,
    title: 'Admin',
    options: [
      { id: 'accountsBtn', title: 'Manage User Accounts', url: '/account/search', inActionMenu: true },
      { id: 'abstractListBtn', title: 'View Abstract List', url: '/abstract/search', inActionMenu: true },
      { id: 'importAbstractBtn', title: 'Import Abstracts', url: '/abstract/import', inActionMenu: true },
      { id: 'createAbstractBtn', title: 'Create Abstracts', url: '/abstract/create', inActionMenu: false },
      { id: 'analyticsBtn', title: 'Site\'s Analytics', url: '/analytics/home', inActionMenu: false }
    ]
  },
  {
    role: Roles.ReconciliationSupervisor,
    title: 'Reconciliation Supervisor',
    options: [
      { id: 'teamsBtn', title: 'Manage Reconciliation Teams', url: '/manage/teams', inActionMenu: true },
      { id: 'abstractListBtn', title: 'View Abstract List', url: '/abstract/search/sup', inActionMenu: true },
      { id: 'qcEligibleAbstractsBtn', title: 'Manage Abstracts for Reconciliation', url: '/abstract/managereconciliation', inActionMenu: true },
      { id: 'codeReconAbstractBtn', title: 'Code Reconciliation Abstracts', url: '/abstract/view/', inActionMenu: true, parameters: { reconSupCoding: true} },
      { id: 'reportsBtn', title: 'Reports', url: '/reports/home', inActionMenu: true }
    ]
  },
  {
    role: Roles.ReconciliationCoder,
    title: 'Reconciliation Coder',
    options: [
      { id: 'codeReconAbstractBtn', title: 'View/Code Reconciliation Abstracts', url: '/abstract/view/', inActionMenu: true },
      { id: 'abstractListBtn', title: 'View Abstract List', url: '/abstract/search/staff', inActionMenu: true }
      /// [Notes:BJL_2025-08] In PACT 3.1, RecommendForReview and InReviewList will be one pool of abstracts for coding.
      /*{ id: 'viewCoderRequestedAbstractsBtn', title: 'View/Code Coder Question Abstracts', url: '/abstract/viewcoderrequested', inActionMenu: false }*/
    ]
  },
  {
    role: Roles.QCSupervisor,
    title: 'QC Supervisor',
    options: [
      { id: 'teamsBtn', title: 'Manage QC Teams', url: '/manage/teams', inActionMenu: true },
      { id: 'abstractListBtn', title: 'View Abstract List', url: '/abstract/search/sup', inActionMenu: true },
      /*{ id: 'codeAbstractBtn', title: 'View/Code Abstracts', url: '/abstract/view/', inActionMenu: true },*/
      /*{ id: 'abstractQclistBtn', title: 'Filter Abstract List', url: '/abstract/qclist', inActionMenu: true },*/
      { id: 'reportsBtn', title: 'Reports', url: '/reports/home', inActionMenu: true }
    ]
  },
  {
    role: Roles.QCCoder,
    title: 'QC Coder',
    options: [
      { id: 'codeAbstractBtn', title: 'View/Code QC Abstracts', url: '/abstract/view/', inActionMenu: true },
      { id: 'abstractListBtn', title: 'View Abstract List', url: '/abstract/search/staff', inActionMenu: true }
    ]
  }
];
